/**
* TextInput.js
* 
* Created on 10-okt-2014, 12:25:28
*
* @author Harm Boschloo for Ranj
* @author Reinier Feijen for Ranj
**/

import DprDOMElement from "../dom/DprDOMElement";
import AbstractTextInput from "./AbstractTextInput";
import TextUtil from "./TextUtil";

export default class TextInput extends AbstractTextInput {
    constructor(target, width, height, htmlContainerId, maxCharacters = 0) {
        super(target, width, height, htmlContainerId, maxCharacters);

        this._init(this._createSingleLineTextInput(width));

        // Prevents createjs wrapping.
        this._target.lineWidth = null;

        this.setWrapText(false);
    }

    _createSingleLineTextInput(width) {
        //works only for single lines!
        const fontSize = TextUtil.getFontSize(this._target) * this._target.scaleX;
        const x = this._target.x;
        const y = this._target.y - 1;

        const inputDOM = document.createElement(`input`);
        inputDOM.setAttribute(`type`, `text`);
        inputDOM.setAttribute(`autocomplete`, `off`);
        inputDOM.setAttribute(`id`, this._id);
        inputDOM.setAttribute(`style`, `
            position: absolute;
            z-index: 199;
            top: 0px;
            left: 0px;
            background: transparent;
            border: 0;
            overflow: hidden;
            resize: none;
            outline: none;
        `);

        const container = document.getElementById(this._htmlContainerId);
        container.appendChild(inputDOM);

        const htmlElement = inputDOM;
        htmlElement.value = this._target.text;
        htmlElement.style.font = this._target.font;
        htmlElement.style.fontSize = fontSize + "px";
        htmlElement.style.color = this._target.color;
        htmlElement.style.width = width + "px";
        htmlElement.style.visibility = "hidden";

        const domElement = new DprDOMElement(htmlElement);
        domElement.x = x;
        domElement.y = y;

        return domElement;
    }
}